/** @typedef {{
 * content:Array,
 * addLazyObserver:Boolean,
 * withBullets:Boolean|false,
 * className:String|null}
 * } T.Glider.Par
 * */
/**
 * @class
 * @param {T.Glider.Par} par
 * @extends mkE.Base
 */
T.Glider = Class(
	/**
	 * @lends {T.Glider#}
	 */
	{
		/** @type {T.Glider.Par} */
		par: {},

		/** @param {T.Glider.Par} par */
		__construct: function ( par ) {
			this.par = par;
			this.node = mkE({
				tag: 'div',
				className: 'glider ' + (par.className || ''),
				els: [
					this._glider = mkE({
						tag: 'div',
						className: 'glide',
						style: {
							position: 'relative'
						},
						els: [
							{
								tag: 'div',
								className: 'glide__track',
								style: {
									overflow: 'hidden'
								},
								attr: {
									"data-glide-el": 'track'
								},
								els: [
									this._content = mkE({
										tag: 'div',
										className: 'glide__slides',
										style: {
											display: 'flex'
										}
									}),
									this._arrows = mkE({
										tag: 'div',
										className: 'glide__arrows',
										attr: {
											"data-glide-el": "controls"
										},
										style: {
											display: 'none'
										},
										els: [
											{
												tag: 'button',
												className: 'glide__arrow glide_arrow--left',
												attr: {
													"data-glide-dir": '<'
												}
											},
											{
												tag: 'button',
												className: 'glide__arrow glide_arrow--right',
												attr: {
													"data-glide-dir": '>'
												}
											}
										]
									}),
									this._bullets = this.par.withBullets ? mkE({
										tag: 'div',
										className: 'glide__bullets',
										attr: {
											"data-glide-el": 'controls[nav]'
										}
									}) : ''
								]
							}
						]
					})
				]
			});
			if (par.content) {
				let content = [];
				for (let i = 0; i < par.content.length; i++) {
					const contentElement = par.content[i];
					content.push({
						tag: 'div',
						className: 'glide__slide',
						els: [
							contentElement
						]
					});
					if(this.par.withBullets) {
						mkE({
							tag: 'button',
							className: 'glide__bullet',
							attr: {
								"data-glide-dir": `=${i}`
							}
						}).append(this._bullets);
					}
				}
				mkE.appendTypeElement(this._content, content);
			}
		},

		goTo( index ) {
			if( !this._slider ) {
				return;
			}
			this._slider.go('=' + index);
		},

		onShow() {
			this._initSlider();
		},

		onLeave() {
			if( this._slider ) {
				this._slider.destroy();
				this._slider = null;
				if( this.lazyImageObserver ) {
					this.lazyImageObserver.disconnect();
					this.lazyImageObserver = null;
				}
			}
		},

		_addObservation() {
			try {
				if( "IntersectionObserver" in window ) {
					this.lazyImageObserver = new IntersectionObserver(function ( entries, observer ) {
						entries.forEach(function ( entry ) {
							if( entry.isIntersecting ) {
								entry.target.classList.remove("lazy");
								observer.unobserve(entry.target);
							}
						});
					});
					for( let i = 0; i < this._content.children.length; i++ ) {
						const lazyImage = this._content.children[i];
						lazyImage.classList.add("lazy");
						this.lazyImageObserver.observe(lazyImage);
					}
				}
			} catch( e ) {
				console.error(e);
			}
		},

		_gap() {
			return 16;
		},

		_peek() {
			if( window.innerWidth < 1134 ) {
				const slideWith = 210;
				const preSlide = window.innerWidth <= slideWith ? 0 : 16;
				const afterSlide = this._glider.offsetWidth - this._perView() * slideWith - preSlide;
				return {before: preSlide, after: afterSlide};
			} else {
				return 0;
			}
		},

		_perView() {
			if( window.innerWidth < 1134 ) {
				const w = this._gap() + 210;
				return Math.floor(this._glider.offsetWidth / w);
			} else {
				return 4;
			}
		},

		_initSlider() {
			D.onLoad('Glide', this._onLoadModule);
		},

		_onLoadModule() {
			this._arrows.style.display = '';
			let config = {
				...{
					type: 'carousel',
					startAt: 0,
					gap: this._gap(),
					peek: this._peek(),
					perView: this._perView(),
					focusAt: 0,
					dragThreshold: false
				},
				...this.par.config
			};
			this._slider = new Glide(this._glider, config);
			this._slider.on('resize', this._onSliderResize);
			this._slider.mount();
			if (this.par.addLazyObserver) {
				this._addObservation();
			}
		},

		_onSliderResize() {
			let config = {
				...{
					gap: this._gap(),
					peek: this._peek(),
					perView: this._perView(),
				},
				...this.par.config
			};
			this._slider.update({
				gap: config.gap,
				peek: config.peek,
				perView: config.perView,
			});
		}

	},
	mkE.Base
);
